import {api} from '~/CreateFabricInvitation/api/api';

export const eventApi = api.injectEndpoints({
  endpoints: (builder) => ({
    send: builder.mutation({
      query: (eventId) => ({
        url: `/ajax/send/${eventId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {useSendMutation} = eventApi;
